/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamMatch
 */
export interface OWGameSteamMatch {
    /**
     * Confidence score of the match
     * @type {number}
     * @memberof OWGameSteamMatch
     */
    confidence?: number;
    /**
     * Method used for matching
     * @type {string}
     * @memberof OWGameSteamMatch
     */
    method?: string;
    /**
     * Overwolf game name
     * @type {string}
     * @memberof OWGameSteamMatch
     */
    overwolfName?: string;
    /**
     * Steam game name
     * @type {string}
     * @memberof OWGameSteamMatch
     */
    steamName?: string;
}

export function OWGameSteamMatchFromJSON(json: any): OWGameSteamMatch {
    return OWGameSteamMatchFromJSONTyped(json, false);
}

export function OWGameSteamMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamMatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confidence': !exists(json, 'confidence') ? undefined : json['confidence'],
        'method': !exists(json, 'method') ? undefined : json['method'],
        'overwolfName': !exists(json, 'overwolfName') ? undefined : json['overwolfName'],
        'steamName': !exists(json, 'steamName') ? undefined : json['steamName'],
    };
}

export function OWGameSteamMatchToJSON(value?: OWGameSteamMatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confidence': value.confidence,
        'method': value.method,
        'overwolfName': value.overwolfName,
        'steamName': value.steamName,
    };
}


